
export enum AiQuickTipEnums {
    KEY_MESSAGES = 'KEY_MESSAGES',
    QUOTES = 'QUOTES'
}
